export const isPlural = (count: number): boolean => count !== 1;
export const getPluralSuffix = (count: number): string => (isPlural(count) ? 's' : '');

export const getConjugatedToBe = (count: number): string => (isPlural(count) ? 'are' : 'is');

export const getConjugatedToHave = (count: number): string => (isPlural(count) ? 'have' : 'has');
